import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import DocsPage from './pages/DocsPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import CookiePolicyPage from './pages/CookiePolicy'
import NotFoundPage from './pages/NotFoundPage'
import './App.css'

function App() {
  return (
    <Routes>
      <Route path='/' element={<LandingPage />} />
      <Route path='/docs/*' element={<DocsPage />} />
      <Route path='/privacy' element={<PrivacyPolicyPage />} />
      <Route path='/cookie-policy' element={<CookiePolicyPage />} />
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}

export default App
